import React from 'react';
import { makeStyles, Spinner } from '@fluentui/react-components';

const useStyles = makeStyles({
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        textAlign: 'center',
        padding: '64px',
        fontSize: '18px',
        color: '#666',
        '& .fui-Spinner': {
            color: '#C6A972',
            '--colorBrandStroke1': '#C6A972',
            '--colorBrandStroke2Contrast': '#F4F0E7',
        },
    },
});

interface AlyzeLoadingSpinnerProps {
    message?: string;
    size?: 'tiny' | 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'huge';
}

export const AlyzeLoadingSpinner: React.FC<AlyzeLoadingSpinnerProps> = ({ 
    message = 'Loading...', 
    size = 'large' 
}) => {
    const styles = useStyles();

    return (
        <div className={styles.loadingContainer}>
            <Spinner size={size} />
            {message && <div>{message}</div>}
        </div>
    );
};
